import React from 'react';
import { getTextColor } from '@src/components/overview-dashboard/metrics-container/spi-widget/SPIMetricsText';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import humanizeValue from '@utils/overview/humanizeValue';
import { LOCAL_METRIC_SWITCH_MAP, getMetricUnit } from '@utils/metrics';
import { StyledCell } from './styled';

// TODO: duplicated from dimension panel cell
// cleanup as not all checks are required for roadmap

function ValueCell({ cellData, column }) {
  if (['NA', 'low'].includes(cellData)) {
    return <StyledCell>{cellData}</StyledCell>;
  }
  const textStyle: any = {};
  let classStr = '';

  if (!column.colorless && column.metric === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 500;
    classStr = 'color-critical';
  }

  // LOCAL_METRIC_SWITCH_MAP contains all the local calculated metrics and its unit is %
  const unit =
    column.mfPctChecked || !!LOCAL_METRIC_SWITCH_MAP[column.metric]
      ? '%'
      : getMetricUnit({ metricKey: column.metric });
  const { humanizedNumber, humanizedUnit } = humanizeValue(cellData, column.metric, unit as string);

  return (
    <StyledCell>
      <span style={textStyle} className={classStr}>
        {`${humanizedNumber} ${humanizedUnit}`}
      </span>
    </StyledCell>
  );
}

export default React.memo(ValueCell);
